var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "cshaped-signature",
    viewBox: "0 0 1502 451",
    width: 140,
    height: 42,
    role: "img",
    "aria-label": "C Shaped handwritten ink animation",
    style: {
      color: "#184342"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cshaped-signature__brush { stroke-dasharray:100 150; stroke-dashoffset:0; }\n@keyframes cshaped-signature-c-0 { 0%, 2.703% { stroke-dashoffset:125; } 18.919%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-s-0 { 0%, 16.216% { stroke-dashoffset:125; } 33.784%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-h-0 { 0%, 31.081% { stroke-dashoffset:125; } 40.541%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-h-1 { 0%, 37.838% { stroke-dashoffset:125; } 48.649%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-a-0 { 0%, 45.946% { stroke-dashoffset:125; } 56.757%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-a-1 { 0%, 54.054% { stroke-dashoffset:125; } 60.811%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-p-0 { 0%, 58.108% { stroke-dashoffset:125; } 64.865%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-p-1 { 0%, 62.162% { stroke-dashoffset:125; } 74.324%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-e-0 { 0%, 71.622% { stroke-dashoffset:125; } 83.784%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-d-0 { 0%, 81.081% { stroke-dashoffset:125; } 91.892%, 100% { stroke-dashoffset:0; } }\n@keyframes cshaped-signature-d-1 { 0%, 89.189% { stroke-dashoffset:125; } 100.000%, 100% { stroke-dashoffset:0; } }\n@media (hover:hover) and (pointer:fine) {\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-c-0\"] { animation:cshaped-signature-c-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-s-0\"] { animation:cshaped-signature-s-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-h-0\"] { animation:cshaped-signature-h-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-h-1\"] { animation:cshaped-signature-h-1 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-a-0\"] { animation:cshaped-signature-a-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-a-1\"] { animation:cshaped-signature-a-1 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-p-0\"] { animation:cshaped-signature-p-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-p-1\"] { animation:cshaped-signature-p-1 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-e-0\"] { animation:cshaped-signature-e-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-d-0\"] { animation:cshaped-signature-d-0 1800ms cubic-bezier(.4,0,.25,1) both; }\n.cshaped-signature:hover [data-stroke=\"cshaped-signature-d-1\"] { animation:cshaped-signature-d-1 1800ms cubic-bezier(.4,0,.25,1) both; }\n}\n@media (prefers-reduced-motion:reduce) { .cshaped-signature__brush { animation:none !important; } }")), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-c",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M164 193 C193 142 156 127 123 143 C68 157 30 282 40 348 C45 407 89 426 137 405 C172 391 190 370 206 345",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 84,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-c-0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-s",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M458 155 C481 108 421 92 387 122 C348 164 385 197 421 228 C490 277 463 357 403 373 C343 390 303 357 320 320 C327 301 341 291 360 291",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 96,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-s-0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-h",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M565 100 L535 383",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-h-0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M551 262 C572 202 599 182 624 194 C658 209 640 269 638 316 C635 355 676 366 707 307",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 80,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-h-1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-a",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M824 177 C793 139 757 174 743 233 C719 306 742 356 782 324 C810 302 825 240 831 179",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 70,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-a-0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M861 153 L845 281 C837 337 884 352 925 276",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 64,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-a-1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-p",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M966 125 L934 439",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 72,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-p-0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M977 193 C1004 150 1051 133 1063 184 C1083 251 1043 329 1000 319 C984 316 977 303 977 291",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-p-1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-e",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M1145 225 C1190 228 1239 179 1226 139 C1204 105 1162 143 1143 209 C1114 311 1202 319 1268 237",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 72,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-e-0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cshaped-signature-d",
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -60,
    width: 1640,
    height: 600,
    style: {
      maskType: "luminance"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M1382 121 C1327 85 1305 141 1291 204 C1267 263 1285 311 1337 271 C1366 251 1375 187 1385 140",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 86,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-d-0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__brush",
    d: "M1426 10 L1403 222 C1393 278 1463 294 1482 223",
    pathLength: 100,
    fill: "none",
    stroke: "white",
    strokeWidth: 68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-stroke": "cshaped-signature-d-1"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cshaped-signature__guide",
    d: "m72.7 337.1q3.4 33 16.5 46.5 13.1 13.1 37.7 10.5 22.7-2.3 41.9-14.8 19.6-12.9 31.5-33.1l9.6 3q-9.6 35.2-40.1 58.9-30.1 23.3-65.5 27-46.2 4.9-69.3-16-22.7-21.4-28.1-72.7-3.5-33 1.1-69.7 4.6-36.7 16.3-66.4 15.3-38.3 40.4-59.8 25.5-22 59.3-25.5 31.8-3.4 50.4 8.8 18.9 11.6 21.6 37.5 1.9 17.9-4.3 28.2-6.2 9.9-19.7 11.3-6.8 0.7-13-1-5.8-2.2-10.8-6.9 6.8-4.4 11.3-15.7 4.4-11.7 3.2-22.9-1.2-11.5-8.2-17.2-7.1-5.7-18.6-4.5-17.5 1.9-32.4 25.1-14.9 22.9-23.7 61.7-6 26.3-7.9 54.7-1.9 27.9 0.8 53zm256.9-161.7q-3.3-30.7 20.9-53.7 24.5-23.1 63.5-27.2 30.2-3.2 48.2 7.4 18.4 10.5 20.8 33.6 1.9 17.9-6.1 30-7.5 12.1-22.3 13.6-5.5 0.6-10.5-0.9-4.6-1.5-8.6-5.5 7.4-5.6 11.2-15.7 4.2-10.1 3.1-20.4-1.4-12.7-9.6-18.7-8.3-6.4-22.7-4.9-17.1 1.8-26 12.4-8.6 10.6-6.8 27.7 1.5 13.9 10 25.9 8.5 11.5 34.5 30.1 34.4 24.2 46.4 43.4 12.1 18.9 14.7 43.5 4.7 45.4-23.9 75.7-28.5 30.4-77.5 35.5-39 4.1-63.5-11.4-24.6-15.5-28-48.1-3-28.7 12.2-48.8 15.2-20.1 39.4-22.6 15.1-1.6 25.4 4.5 10.3 5.8 12.4 18.1-20.7 2.1-32.8 13.5-11.7 11.2-9.8 28.7 1.7 16.7 13.2 26.4 11.5 9.7 29 7.8 20.7-2.2 31.9-17.8 11.2-15.7 8.7-39.9-2-18.7-12.2-35-10.1-16.2-39.4-42.1-26.5-22.9-35.6-36.5-8.7-13.9-10.2-28.6zm282.3 156.9q-0.7-7.2-0.3-18.1 0.9-10.9 4-35 3.2-23.2 3.7-33.3 0.6-10.2-0.1-16.9-1.1-10-5.6-14.7-4.1-4.8-11.3-4.1-9.5 1-17.5 13.5-7.6 12.1-9 24.7l-13.9 132.2-57.3 6 29.3-276.6 58-14.1-10.9 102.5q8.7-12.2 19.7-19 10.9-6.7 24.5-8.2 21-2.2 33.8 8.1 12.7 10.4 15 32.2 1 9.2-0.1 22.2-0.6 12.5-4.3 39-3 20.9-3.7 29.4-0.8 8.5-0.2 14.1 0.9 8.3 5.3 12.3 4.4 3.6 12.4 2.7 9.9-1 16.4-8.5 6.4-7.6 13.3-30l16.7-1.7q-8.8 38.3-25.2 58.5-16 20.2-41 22.8-22.3 2.4-35.9-8.3-13.6-11-15.8-31.7zm219-162.6l0.3 2.8 2.2-21.5 57.3-6.1-14.5 138.3q-0.4 3.7-0.4 6.9-0.2 2.8 0.2 6 0.9 8.8 5.3 12.7 4.4 3.6 12.8 2.7 10.3-1.1 17.7-11.5 7.3-10.8 10.6-29.3l16.7-1.7q-8.9 37.9-27.2 58.7-18.4 20.5-45 23.3-17.1 1.8-28.5-6.7-10.9-8.5-14.4-25.8-10.4 19.6-24.5 30.3-13.8 10.7-30.9 12.5-24.7 2.6-40.7-12.6-15.7-15.3-18.9-45.9-2.4-22.3 1.8-47.3 4.2-24.9 14.1-46.1 12.2-25 30.4-39.4 18.2-14.8 41.3-17.2 15.5-1.6 24.4 3.1 8.9 4.3 9.9 13.8zm-11.2 111.8l9.7-91.9q-0.6-6-5.5-9.9-4.8-4.3-12.4-3.5-21.9 2.3-35.1 40.7-12.9 38.3-9.1 74.1 1.6 15.6 6.8 23.1 5.2 7 16.3 5.9 10.3-1.1 18.9-12.1 8.9-10.9 10.4-26.4zm168.5-100.2l-11.8 113.9q2.1 4.2 6.3 6.2 4.2 1.9 9.8 1.4 25.1-2.7 36.8-36.5 12.1-33.8 7.7-76.4-1.8-16.3-7.4-24.2-5.7-7.8-16-6.7-7.2 0.7-14.1 7.1-7 5.9-11.3 15.2zm-15 144l-10.5 99.2-58.6 20.7 33.5-320.1 57.3-6-3.2 30.5q9.1-9.4 20.1-15 11.1-5.6 24.6-7 23.9-2.5 37.9 12.1 14 14.6 17.3 45.7 6.4 60.8-15.7 103.4-21.7 42.5-67.4 47.3-12.7 1.3-21.9-1.4-8.7-2.7-13.4-9.4zm276.7-183.1q3.5 33-21 60.5-24.5 27.1-61.6 33 0.3 6.8 0.3 10.5 0.3 3.1 0.5 5.5 2 18.3 8.7 25.3 7.2 6.8 23.5 5.1 18.7-1.9 33.3-11.9 15-10.4 32.9-35.7l13.5-1.4q-19.1 39.8-44.3 61-25.1 20.7-57.4 24.1-30.6 3.2-48.2-11-17.2-14.3-20.5-45.7-2.3-22.7 2.1-48.9 4.5-26.2 14.4-47.4 12.2-25.4 31.2-39.4 19.4-14.5 44.9-17.2 21.8-2.3 33.6 6.1 12.1 8 14.1 27.5zm-42.3-12.9q-13.6 1.5-24.9 27.2-11.1 25.3-14.3 59.8 22.9-4 38-25.3 15.4-21.7 12.8-46.4-0.9-8.4-3.7-12.1-2.8-3.7-7.9-3.2zm115.4 103.3q1.6 15.5 6.8 23 5.2 7.1 16.3 6 10-1.1 18.6-11.2 8.5-10.6 10.6-25.3l-0.2-2 9.9-93.1q-1.9-6.3-6.6-9.4-4.4-3.5-11.2-2.8-21.8 2.3-35.1 40.7-12.9 38.3-9.1 74.1zm63.7-121.3l0.1 1.6 9.9-93.5 58-14.2-23.1 219.6q-0.4 3.7-0.5 6.9-0.1 2.9 0.2 6 0.9 8 4.8 11.2 4.3 2.8 13.1 1.8 10.3-1 17.7-11.1 7.4-10 10.8-27.3l16.7-1.7q-8.6 36.7-26.6 56.7-17.6 19.9-45.8 22.9-16.4 1.7-27.6-5.9-10.9-8.2-15-24.2-10 19.5-23.8 30.2-13.8 10.7-31.3 12.6-24.6 2.6-40.7-12.6-15.7-15.3-18.9-45.9-2.3-22.3 1.9-47.3 4.2-24.9 14-46.1 12.3-25 30.5-39.4 18.1-14.8 41.2-17.2 15.5-1.6 24.5 3.1 8.9 4.3 9.9 13.8z",
    fill: "currentColor",
    opacity: 0.12
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "c",
    d: "M72.7 337.1q3.4 33 16.5 46.5 13.1 13.1 37.7 10.5 22.7-2.3 41.9-14.8 19.6-12.9 31.5-33.1l9.6 3q-9.6 35.2-40.1 58.9-30.1 23.3-65.5 27-46.2 4.9-69.3-16-22.7-21.4-28.1-72.7-3.5-33 1.1-69.7 4.6-36.7 16.3-66.4 15.3-38.3 40.4-59.8 25.5-22 59.3-25.5 31.8-3.4 50.4 8.8 18.9 11.6 21.6 37.5 1.9 17.9-4.3 28.2-6.2 9.9-19.7 11.3-6.8 0.7-13-1-5.8-2.2-10.8-6.9 6.8-4.4 11.3-15.7 4.4-11.7 3.2-22.9-1.2-11.5-8.2-17.2-7.1-5.7-18.6-4.5-17.5 1.9-32.4 25.1-14.9 22.9-23.7 61.7-6 26.3-7.9 54.7-1.9 27.9 0.8 53z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-c)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "s",
    d: "M329.6 175.4q-3.3-30.7 20.9-53.7 24.5-23.1 63.5-27.2 30.2-3.2 48.2 7.4 18.4 10.5 20.8 33.6 1.9 17.9-6.1 30-7.5 12.1-22.3 13.6-5.5 0.6-10.5-0.9-4.6-1.5-8.6-5.5 7.4-5.6 11.2-15.7 4.2-10.1 3.1-20.4-1.4-12.7-9.6-18.7-8.3-6.4-22.7-4.9-17.1 1.8-26 12.4-8.6 10.6-6.8 27.7 1.5 13.9 10 25.9 8.5 11.5 34.5 30.1 34.4 24.2 46.4 43.4 12.1 18.9 14.7 43.5 4.7 45.4-23.9 75.7-28.5 30.4-77.5 35.5-39 4.1-63.5-11.4-24.6-15.5-28-48.1-3-28.7 12.2-48.8 15.2-20.1 39.4-22.6 15.1-1.6 25.4 4.5 10.3 5.8 12.4 18.1-20.7 2.1-32.8 13.5-11.7 11.2-9.8 28.7 1.7 16.7 13.2 26.4 11.5 9.7 29 7.8 20.7-2.2 31.9-17.8 11.2-15.7 8.7-39.9-2-18.7-12.2-35-10.1-16.2-39.4-42.1-26.5-22.9-35.6-36.5-8.7-13.9-10.2-28.6z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-s)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "h",
    d: "M611.9 332.3q-0.7-7.2-0.3-18.1 0.9-10.9 4-35 3.2-23.2 3.7-33.3 0.6-10.2-0.1-16.9-1.1-10-5.6-14.7-4.1-4.8-11.3-4.1-9.5 1-17.5 13.5-7.6 12.1-9 24.7l-13.9 132.2-57.3 6 29.3-276.6 58-14.1-10.9 102.5q8.7-12.2 19.7-19 10.9-6.7 24.5-8.2 21-2.2 33.8 8.1 12.7 10.4 15 32.2 1 9.2-0.1 22.2-0.6 12.5-4.3 39-3 20.9-3.7 29.4-0.8 8.5-0.2 14.1 0.9 8.3 5.3 12.3 4.4 3.6 12.4 2.7 9.9-1 16.4-8.5 6.4-7.6 13.3-30l16.7-1.7q-8.8 38.3-25.2 58.5-16 20.2-41 22.8-22.3 2.4-35.9-8.3-13.6-11-15.8-31.7z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-h)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "a",
    d: "M830.9 169.7l0.3 2.8 2.2-21.5 57.3-6.1-14.5 138.3q-0.4 3.7-0.4 6.9-0.2 2.8 0.2 6 0.9 8.8 5.3 12.7 4.4 3.6 12.8 2.7 10.3-1.1 17.7-11.5 7.3-10.8 10.6-29.3l16.7-1.7q-8.9 37.9-27.2 58.7-18.4 20.5-45 23.3-17.1 1.8-28.5-6.7-10.9-8.5-14.4-25.8-10.4 19.6-24.5 30.3-13.8 10.7-30.9 12.5-24.7 2.6-40.7-12.6-15.7-15.3-18.9-45.9-2.4-22.3 1.8-47.3 4.2-24.9 14.1-46.1 12.2-25 30.4-39.4 18.2-14.8 41.3-17.2 15.5-1.6 24.4 3.1 8.9 4.3 9.9 13.8z M819.7 281.5l9.7-91.9q-0.6-6-5.5-9.9-4.8-4.3-12.4-3.5-21.9 2.3-35.1 40.7-12.9 38.3-9.1 74.1 1.6 15.6 6.8 23.1 5.2 7 16.3 5.9 10.3-1.1 18.9-12.1 8.9-10.9 10.4-26.4z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-a)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "p",
    d: "M988.2 181.3l-11.8 113.9q2.1 4.2 6.3 6.2 4.2 1.9 9.8 1.4 25.1-2.7 36.8-36.5 12.1-33.8 7.7-76.4-1.8-16.3-7.4-24.2-5.7-7.8-16-6.7-7.2 0.7-14.1 7.1-7 5.9-11.3 15.2z M973.2 325.3l-10.5 99.2-58.6 20.7 33.5-320.1 57.3-6-3.2 30.5q9.1-9.4 20.1-15 11.1-5.6 24.6-7 23.9-2.5 37.9 12.1 14 14.6 17.3 45.7 6.4 60.8-15.7 103.4-21.7 42.5-67.4 47.3-12.7 1.3-21.9-1.4-8.7-2.7-13.4-9.4z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-p)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "e",
    d: "M1249.9 142.2q3.5 33-21 60.5-24.5 27.1-61.6 33 0.3 6.8 0.3 10.5 0.3 3.1 0.5 5.5 2 18.3 8.7 25.3 7.2 6.8 23.5 5.1 18.7-1.9 33.3-11.9 15-10.4 32.9-35.7l13.5-1.4q-19.1 39.8-44.3 61-25.1 20.7-57.4 24.1-30.6 3.2-48.2-11-17.2-14.3-20.5-45.7-2.3-22.7 2.1-48.9 4.5-26.2 14.4-47.4 12.2-25.4 31.2-39.4 19.4-14.5 44.9-17.2 21.8-2.3 33.6 6.1 12.1 8 14.1 27.5z M1207.6 129.3q-13.6 1.5-24.9 27.2-11.1 25.3-14.3 59.8 22.9-4 38-25.3 15.4-21.7 12.8-46.4-0.9-8.4-3.7-12.1-2.8-3.7-7.9-3.2z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-e)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    "data-letter": "d",
    d: "M1323 232.6q1.6 15.5 6.8 23 5.2 7.1 16.3 6 10-1.1 18.6-11.2 8.5-10.6 10.6-25.3l-0.2-2 9.9-93.1q-1.9-6.3-6.6-9.4-4.4-3.5-11.2-2.8-21.8 2.3-35.1 40.7-12.9 38.3-9.1 74.1z M1386.7 111.3l0.1 1.6 9.9-93.5 58-14.2-23.1 219.6q-0.4 3.7-0.5 6.9-0.1 2.9 0.2 6 0.9 8 4.8 11.2 4.3 2.8 13.1 1.8 10.3-1 17.7-11.1 7.4-10 10.8-27.3l16.7-1.7q-8.6 36.7-26.6 56.7-17.6 19.9-45.8 22.9-16.4 1.7-27.6-5.9-10.9-8.2-15-24.2-10 19.5-23.8 30.2-13.8 10.7-31.3 12.6-24.6 2.6-40.7-12.6-15.7-15.3-18.9-45.9-2.3-22.3 1.9-47.3 4.2-24.9 14-46.1 12.3-25 30.5-39.4 18.1-14.8 41.2-17.2 15.5-1.6 24.5 3.1 8.9 4.3 9.9 13.8z",
    fill: "currentColor",
    mask: "url(#cshaped-signature-d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHover);
export default __webpack_public_path__ + "static/media/logo-hover.97ce1078116374452d06263dd67410d7.svg";
export { ForwardRef as ReactComponent };